import React, { Fragment } from 'react';
import FilterOrderRowView from './filterorderrowview';
import FilterOrderRowEdit from './filterorderrowedit';

export default function FilterOrder(props) {
    const editingOrder = props.editOrderedItem;

    const onClickRow = () => {
        if (props.selected) return;
        props.clickRow(props.filterOrder.id);
    };
    const onClickToSelect = (id) => {
        props.clickSelect(id);
    };

    return (
        <Fragment>
            {!props.editRow ? (
                <FilterOrderRowView
                    index={props.index}
                    editingOrder={editingOrder}
                    selected={props.selected}
                    filterOrder={props.filterOrder}
                    startEditRow={onClickRow}
                    selectRow={onClickToSelect}
                    customerView={props.customerView}
                    allowPricing={props.allowPricing}
                    editFoPalletInfo={props.editFoPalletInfo}
                    fadeRow={props.fadeRow}
                    priceOnly={props.priceOnly}
                    filterOrderChanged={props.filterOrderChanged}
                    currency={props.currency}
                />
            ) : (
                <FilterOrderRowEdit
                    index={props.index}
                    editingOrder={editingOrder}
                    selected={props.selected}
                    filterOrder={props.filterOrder}
                    customerView={props.customerView}
                    allowPricing={props.allowPricing}
                    closeRowEdit={props.closeRowEdit}
                    filterOrderChanged={props.filterOrderChanged}
                    priceOnly={props.priceOnly}
                    saving={props.saving}
                    currency={props.currency}
                />
            )}
        </Fragment>
    );
}
